import { IProps } from '@/Interfaces/Icons/Props.interface';

const CaptureIcon = (props: IProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24' {...props}>
    <path
      fill='currentColor'
      d='M3 9a1 1 0 001-1V5a1 1 0 011-1h3a1 1 0 000-2H5a3 3 0 00-3 3v3a1 1 0 001 1zm5 11H5a1 1 0 01-1-1v-3a1 1 0 10-2 0v3a3 3 0 003 3h3a1 1 0 000-2zm4-12a4 4 0 100 8 4 4 0 000-8zm0 6a2 2 0 110-4 2 2 0 010 4zm7-12h-3a1 1 0 100 2h3a1 1 0 011 1v3a1 1 0 002 0V5a3 3 0 00-3-3zm2 13a1 1 0 00-1 1v3a1 1 0 01-1 1h-3a1 1 0 000 2h3a3 3 0 003-3v-3a1 1 0 00-1-1z'
    ></path>
  </svg>
);

export default CaptureIcon;
